import React from 'react';
import './CourseFeatures.css';

const CourseFeatures: React.FC = () => {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = e.target as HTMLImageElement;
    target.style.display = 'none';
  };

  return (
    <section className="course-features" data-section="course-features">
      <div className="container course-features-container">
        <div className="course-features-header">
          <h2>Unsere <span className="highlight-text">Kursmerkmale</span></h2>
          <p>Erfahren Sie mehr über unseren didaktischen und technischen Ansatz in der KI-Ausbildung.</p>
        </div>
        
        <div className="features-grid">
          <div className="feature-section pedagogical">
            <div className="feature-visual">
              <img 
                src="/assets/images/ki-kurse/course-features/mintkitchen-kiKurse-konzept_2.svg" 
                alt="Didaktisches Konzept Illustration"
                className="feature-illustration"
                onError={handleImageError}
              />
            </div>
            <div className="feature-content">
              <h3>Unser didaktisches Konzept</h3>
              <p className="feature-intro">
                Wir führen unsere KI-Kurse betriebs- und branchenübergreifend in einer Gruppengröße von 20 - 40 Teilnehmenden durch. 
                Somit ermöglichen wir einen maximalen Erfahrungsaustausch zum komplexen Thema KI.
              </p>
              <ul className="feature-list">
                <li>
                  <strong>Hoher Praxisbezug:</strong> Transfer der Inhalte in den eigenen Betrieb
                </li>
                <li>
                  <strong>Projektorientierung:</strong> Lernen anhand realer KI-Projekte
                </li>
                <li>
                  <strong>Community:</strong> Austausch über reale KI-Projekte und hilfreiche Tipps für die Umsetzung im Betrieb
                </li>
              </ul>
            </div>
          </div>

          <div className="feature-section technical">
            <div className="feature-visual">
              <img 
                src="/assets/images/ki-kurse/course-features/mintkitchen-kiKurse-konzept_1.svg" 
                alt="Technischer Ansatz Illustration"
                className="feature-illustration"
                onError={handleImageError}
              />
            </div>
            <div className="feature-content">
              <h3>Unser technischer Ansatz</h3>
              <p className="feature-intro">
                Im Kurs betrachten wir sinnvolle und niedrigschwellige KI-Anwendungen im Betrieb basierend auf interpretierenden 
                und generierenden Machine Learning-Algorithmen.
              </p>
              <ul className="feature-list">
                <li>
                  <strong>Interpretierende KI:</strong> Computer Vision und Anomalieerkennung u.a. für Produktion und Logistik
                </li>
                <li>
                  <strong>Generierende KI:</strong> Bild-, Text- und Audiogeneratoren u.a. für Verwaltung
                </li>
                <li>
                  <strong>KI-Erprobung:</strong> Bewährte Vorgehensmodelle zur Ermittlung der technischen Machbarkeit von KI-Anwendungsideen
                </li>
                <li>
                  <strong>Erfahrung:</strong> Fachlicher Input von Dozenten mit einschlägiger Entwicklungserfahrung im industriellen Bereich
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CourseFeatures;
